<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="pushLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="pushError" class="mc-error">{{ pushError }}</div>
      <div v-if="pushLoaded" class="mc-notifications">
        <ul v-if="push.length > 0" class="mc-notifications__list">
          <li v-for="item in push" :key="item.id" class="mc-notifications__item">
            <a @click="read(item)" class="mc-notifications__link">
              <p class="mc-notifications__title">
                {{ item.name }}<br>
                {{ item.text }}
              </p>
              <span class="mc-notifications__date">
                                    {{ item.date }}
                                </span>
            </a>
          </li>
        </ul>
        <div v-if="push.length == 0" class="mc-notifications__empty">
          Все уведомления просмотрены
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  mounted() {

  },
  created() {
    this.fetchPush();
  },
  computed: {
    ...mapGetters([
      'push',
      'pushLoading',
      'pushError',
      'pushLoaded',
    ]),
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchPush',
        'readPush'
    ]),
    read(item) {
      this.readPush(item);
      if (item.url)
        this.$router.push(item.url);
    }
  },
}
</script>

